import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Api from './api';
import { NativeComm } from './comm';
import { NativeResultDTO } from './dto/NativeResultDTO';
import { NativePushTokenDto, NativePushMessageDto, NativeConfDto } from './dto/NativeDTOs';
import { setNativeWebview } from './react-queries/queries';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

let pushTokenPromise: Promise<NativeResultDTO<NativePushTokenDto>> | null = null;
let pushMessagePromise: Promise<NativeResultDTO<NativePushMessageDto>> | null = null;

function initApp() {
  pushTokenPromise = Api.beginPushToken((tokenDto) => {
    console.log('push token : ', JSON.stringify(tokenDto));
    //appCtx.setPushToken(tokenDto.token)
  });

  pushMessagePromise = Api.beginPushMessage((msgDto) => {
     console.log('push message : ', JSON.stringify(msgDto))
  //  if (msgDto.type === 'initial' && msgDto.data) {
      //window.sessionStorage.setItem('initialPushType', msgDto.data.msgTypeNo);
      //window.sessionStorage.setItem('initialPushTarget', msgDto.data.targetId);
  //  }
  });

  Api.setEventOnInBG(false);
}

function closeApp() {
  if (null != pushTokenPromise) {
    Api.endPushToken(pushTokenPromise);
    pushTokenPromise = null;
  }

  if (null != pushMessagePromise) {
    Api.endPushMessage(pushMessagePromise);
    pushMessagePromise = null;
  }
}

function renderAppInWebview(conf: NativeConfDto) {
  root.render(
    <React.StrictMode>
      <App
        accessToken={conf.accessToken ? conf.accessToken : ''}
        refreshToken={conf.refreshToken ? conf.refreshToken : ''}
        isWebview={true}
      />
    </React.StrictMode>
  );
}

const RootInBrowser = () => {
  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');
  return (
    <React.StrictMode>
      <App 
        accessToken={accessToken ? accessToken : ''}
        refreshToken={refreshToken ? refreshToken : ''} 
        isWebview={false}
      />
    </React.StrictMode>
  );
}

function renderAppInBrowser() {
  root.render(
    <RootInBrowser/>
  );
}

if (
  !new NativeComm().onReady((conf: NativeConfDto): boolean => {
    setNativeWebview(true);
    initApp();
    renderAppInWebview(conf);
    return true;
  })
) {
  setNativeWebview(false);
  renderAppInBrowser();
  
} /*else if ((window as any).NativeCallGateway) {
  alert('index.tsx: NativeCallGateway found');
  setNativeWebview(false);
  renderAppInBrowser();
  //(window as any).NativeCallGateway.postMessage('ready');
} else {
  alert('index.tsx: NativeCallGateway not found');
  setNativeWebview(false);
  renderAppInBrowser();
  //console.error('NativeCallGateway not found');
}*/

new NativeComm().onExit((conf: NativeConfDto): boolean => {
  closeApp();
  return true;
});

reportWebVitals();
